const TRANSLATE = {
  title: 'Users',
  'menu.import': 'Import',
  'menu.export': 'Export',
  'menu.exportHistory': 'Export History',
  'menu.group': 'Groups List',
  'menu.publicToken': 'Public token',
  name: 'Name',
  email: 'Email',
  group: 'Group',
  profile: 'Profile',
  newApp: 'New app?',
  enabled: 'Enabled',
  fields: {
    NAME: 'Name',
    EMAIL: 'Email',
    GROUP_NAME: 'Group',
    PROFILE_NAME: 'Profile',
    LAST_LOGIN_AT: 'Last login'
  },
  pageGuide: {
    description:
      'In users, you will give access to all people on your team who will use Btime! Here you can organize your team through profiles, defining what each one has access to and what they can or cannot do',
    howToCreate: 'How to create a user?',
    howToEdit: 'How to edit a user?',
    howToDelete: 'How to delete a user?',
    howToFilter: 'How to filter the users list?',
    contactSupport: 'Contact us and get your questions answered'
  }
}

export default TRANSLATE
